// extracted by mini-css-extract-plugin
export default {"section":"styles_section__u4C3z","title":"styles_title__N-hO+","btns":"styles_btns__r6yFM"};